export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Can you replace just the window glass?',
    answer:
      'Often, yes. If the frame is sound, replacing the glass or the insulated glass unit is usually the practical fix. We inspect the frame and hardware first, then recommend new glass or a complete window based on what we find.',
  },
  {
    question: 'Do you help with auto insurance?',
    answer:
      'We work with most insurance companies and can help coordinate your quote and claim paperwork. Your coverage and deductible depend on your own policy, so we recommend confirming those details with your insurer.',
  },
  {
    question: 'Do you offer same-day auto glass?',
    answer:
      'Same-day service may be available depending on your vehicle, the glass we need to source and the day’s schedule. Call us first and we will check the fastest available opening.',
  },
  {
    question: 'When should I measure for shower glass?',
    answer:
      'Contact us early so your enclosure can be planned around the rest of the project. Final measurement happens after the tile, walls and curb are complete, and our team takes the exact measurements for fabrication.',
  },
  {
    question: 'What should I have ready for a quote?',
    answer:
      'For home glass, a photo, the location in the house and rough dimensions help. For vehicles, the year, make, model and which pane is damaged. For commercial work, any drawings and your timeline let us scope it accurately.',
  },
]

